export const indonesianFormat = Intl.NumberFormat('id-ID');
